import { PACKAGE_BIG } from 'app/domains/companies';
function isNotTopPlan(companyPlan) {
    return companyPlan.plan.type !== PACKAGE_BIG.type;
}
export function shouldDisplayUpgradeButton(plans) {
    var _a;
    if (plans == null || (plans === null || plans === void 0 ? void 0 : plans.length)) {
        return (_a = plans === null || plans === void 0 ? void 0 : plans.some(isNotTopPlan)) !== null && _a !== void 0 ? _a : false;
    }
    return true;
}
